import { requestJson } from "@/utils/http";

/**
 * @param {string} apiHost
 * @param {string} token
 * @param {string} uuid
 */
export const checkToken = (apiHost, token, uuid) =>
  requestJson(apiHost + "/api/check_token", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      uuid,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: {},
  });

/**
 * @param {string} apiHost
 * @param {Record<string, string>} headers
 * @param {{ name: string, password: string, type: number }} payload
 */
export const login = (apiHost, headers, payload) =>
  requestJson(apiHost + "/api/login", {
    method: "POST",
    headers,
    body: payload,
  });

/**
 * @param {string} apiHost
 * @param {Record<string, string>} headers
 */
export const logout = (apiHost, headers) =>
  requestJson(apiHost + "/api/logout", {
    method: "POST",
    headers,
    body: {},
  });
